import io from 'socket.io-client';
import Vue from 'vue';
import EscPosEncoder, { PrintFormat } from '../lib/print/EscPosEncoder';
import {
  concatTypedArrays,
  displayPrice,
  getDisplayOptions,
  loadImage,
} from '../utils';
import { IOrder } from '../interfaces/IOrder';
import { OrderType } from '../enums/OrderEnums';
import { vueData } from '../VueData';
import { Globals } from './Globals';
import { AlertType } from '../interfaces/IAlert';
import { usePrinting } from '@/composition/use-printing';
import { LabelPrinter } from '@/lib/print/LabelPrinter';
import { IPrinter } from '@/interfaces/IPrinter';

export enum PrinterType {
  Ticket = 0,
  Comanda = 1,
  Etiqueta = 2,
}

export enum PrintPluginStatus {
  Disconnected = 0,
  Connecting = 1,
  Connected = 2,
}

export interface IPrintPluginInfo {
  version: string;
  /** >= 2 identifies the new print bridge's legacy socket.io emulation. */
  protocol?: number;
  name?: string;
  capabilities?: { printAck?: boolean };
}

export default class PrintService {
  printing = usePrinting();
}
